// ==========================================================================
// phaneuf-erp.js, powered by groots
// Author: Globalia
// Licensed under the WTFPL license
// ==========================================================================

// groots core !! DO NOT DELETE !!
// --------------------------------------------------------------------------

require('_groots.js');

// Display debug informations
window.groots.verbose = false;

// Require groots JS-Plugins
window.groots.plugins = {
    grInlineSVG: require('grInlineSVG/grInlineSVG.js'),
    grObjectfitEmulator: require('grObjectfitEmulator/grObjectfitEmulator.js'),
    grEqualizer: require('grEqualizer/grEqualizer.js'),
    grLazyLoader: require('grLazyLoader/grLazyLoader.js'),
    grNavigation: require('grNavigation/grNavigation.js'),
    grFormSelect: require('grFormSelect/grFormSelect.js'),
    //grFormSelect: false, require('grFormSelect/grFormSelect.js'),
    grFormUpload: require('grFormUpload/grFormUpload.js'),
    grFormNormalize: false,
    grFormValidation: require('grFormValidation/grFormValidation.js'),
    grAccTabs: false,
    grVideoYoutube: false, //require('grVideoYoutube/grVideoYoutube.js'),
    grGoogleMap: require('grGoogleMap/grGoogleMap.js')
};

// ==========================================================================
// Components
// ==========================================================================
require('./_pollyfill.js');
require('./_navigation.js');
require('./_links.js');
require('./_gallery.js');
require('./_product-gallery.js');
require('./_carousel.js');
// require('./_google-map.js');
require('./_bundle.js');
require('./_filters.js');
require('./_tooltip.js');
// require('./_accordion.js');
require('./_toggle.js');
require('./_modal.js');
require('./_tabs.js');
require('./_scrollto.js');
require('./_download.js');
// require('./_youtube.js');
require('./_logiflex.js');
require('./_nav-header.js');
require('./_nav-dropdown.js');
require('./_zone-membre.js');
require('./_password-reveal.js');
require('./_service-call.js');
//require('./_fabrics.js'); // Legacy - The new version is /refonte-2022/_c-fabric.js

// refonte 2022
require('./refonte-2022/_c-gallery.js');
require('./refonte-2022/_c-modal.js');
require('./refonte-2022/_c-select.js');
require('./refonte-2022/_c-fabric.js');
require('./refonte-2022/_c-bundle.js');
require('./refonte-2022/_c-showrooms.js');
require('./refonte-2022/_c-toggler.js');
require('./refonte-2022/_c-nav-search.js');
require('./refonte-2022/_c-populate-contact-email.js');
require('./refonte-2022/_c-clipboard.js');
